import React, { ReactNode } from 'react';
import { Provider, ReactReduxContext } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import Router from './components/router';
import Loader from './components/common/loader';
import { stripeElementsOptions } from './components/accounts/modal/paymentAndBilling/stripeUtils';
import { STRIPE_PUBLIC_KEY } from './config';
import { isOnlyProduction, isOnlyRelease } from './utils/platform';
import { FavIcon } from './components/common/favIcon';
import { isExternalClient } from './utils/clients';
import { getAppTitle } from './utils/utils';

export const stripe = loadStripe(STRIPE_PUBLIC_KEY);

class App extends React.Component {
  componentDidMount(): void {
    this.renderUserPilot();
    this.setAppTitle();
  }

  private setAppTitle() {
    document.title = getAppTitle();
  }

  private renderUserPilot(): void {
    if ((isOnlyRelease() || isOnlyProduction()) && !isExternalClient()) {
      const script = document.createElement('script');
      script.src = '/userpilot.prod.js';
      document.head.appendChild(script);
      const scriptSDK = document.createElement('script');
      scriptSDK.src = 'https://userpilot.sightx.io/sdk/latest.js';
      document.head.appendChild(scriptSDK);
    }
  }

  render(): ReactNode {
    return <>
      <FavIcon />
      <Provider store={store} context={ReactReduxContext}>
        <Elements stripe={stripe} options={stripeElementsOptions}>
          <PersistGate persistor={persistor}>
            <React.Suspense fallback={<Loader/>}>
              <Router/>
            </React.Suspense>
          </PersistGate>
        </Elements>
      </Provider>
    </>;
  }
}

export default App;
